module.exports = __webpack_public_path__ + "static/media/LS.75282372.svg";